import { Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { StaticMetricMenuType } from 'Angular/services/static-menus/types/static-menu-type.type';
import { CalcSearchTypes } from 'CalculationsApp/ts/types/calc-search-types.type';
import { StaticMetricMenuCategory } from 'Angular/services/static-menus/interfaces/static-metric-menu.interface';

import { StaticMenuService } from 'Angular/services/static-menus/static-menus.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';

import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';

/**
 * Metric Selector Modal Directive
 *
 * A modal that allows users to select metrics. This should not be used directly, instead us a component that extends
 * this directive.
 *
 * This component is extended by: SingleMetricSelectorModal, MultiMetricSelectorModal
 *
 * Inputs:
 *   metricMenuType: The type of metrics that should be shown
 *   searchType: The type of search results to display in the add button autocomplete in the modal.
 *   fetchCategories: Whether or not to call staticMenuService to fetch categories.
 *   showInfoPopover: Whether or not to show info popover for individual items.
 *   defaultOnly: bool needed for Data Independence to know if we are on RB or Quote page AND that we are set the Default View
 *
 * Outputs:
 *   selectMetricHandler: An event emitter that emits the selected metric.
 */
@Directive()
export abstract class MetricSelectorModalDirective implements OnChanges {
    @ViewChild(FeatureNeededComponent) featureNeededModal!: FeatureNeededComponent;

    @Input() searchType!: CalcSearchTypes;

    @Input() fetchCategories = true;

    @Output() closeHandler: EventEmitter<void> = new EventEmitter<void>();

    @Input() categories: StaticMetricMenuCategory[] = [];

    @Input() showInfoPopover: boolean = true;

    @Input() defaultOnly: boolean = false;

    readonly MENU_TYPE = 'metricMenu';

    open: boolean = false;

    metricMenuType!: StaticMetricMenuType;

    constructor(protected featureService: FeatureService, protected staticMenuService: StaticMenuService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.fetchCategories) {
            // Depending on the `metricMenuType`, fetch different menu options to display
            if ((changes.searchType?.currentValue && this.searchType) || changes.defaultOnly) {
                this.metricMenuType = this.searchType.replace('_calc', '') as StaticMetricMenuType;

                this.staticMenuService
                    .getStaticMenu(this.MENU_TYPE, this.metricMenuType, this.defaultOnly)
                    .subscribe((response: StaticMetricMenuCategory[]) => {
                        this.categories = response;
                    });
            }
        }
    }

    openModal(): void {
        this.resetModal();
        this.open = true;
    }

    closeModal(): void {
        this.open = false;
        this.closeHandler.emit();
    }

    resetModal(): void {}
}
